import { createFileRoute, redirect } from "@tanstack/react-router";
import { Role } from "@/core/components/auth/auth.types";
import { payoutProvidersQueryOptions } from "@/core/components/commissions/commissionsQueryOptions";
import {
	payoutLegsQueryOptions,
	payoutsSummaryQueryOptions,
} from "@/core/components/commissions/payouts-report/payoutsReportQueryOptions";
import {
	toPayoutsReportFilters,
	validatePayoutsReportSearch,
} from "@/core/components/commissions/payouts-report/payoutsReportSearch";
import { ErrorComponent } from "@/core/components/ErrorComponent";
import { LoadingList } from "@/core/components/LoadingList";
import { getGroupsQueryOptions } from "@/core/components/sites/propertyQueryOptions";

export const Route = createFileRoute(
	"/_layout/dashboard/commissions/payouts-report/",
)({
	validateSearch: validatePayoutsReportSearch,
	beforeLoad: ({ context: { auth } }) => {
		if (auth.isExpired()) {
			return;
		}
		if (!auth.isAuthenticated) {
			throw redirect({ to: "/" });
		}
		// Internal-only, matching the authGuard on every /api/payouts route.
		if (auth.user?.role !== Role.Internal) {
			throw redirect({ to: "/dashboard" });
		}
	},
	// The KPI currency only switches the cards; it must not refetch.
	loaderDeps: ({ search: { kpiCurrency: _kpiCurrency, ...search } }) => search,
	loader: ({ context: { queryClient, auth }, deps }) => {
		const token = auth.token ?? "";
		const filters = toPayoutsReportFilters(deps);
		// eslint-disable-next-line @typescript-eslint/no-floating-promises
		queryClient.ensureQueryData(getGroupsQueryOptions(token));
		// eslint-disable-next-line @typescript-eslint/no-floating-promises
		queryClient.ensureQueryData(payoutProvidersQueryOptions(token));
		// eslint-disable-next-line @typescript-eslint/no-floating-promises
		queryClient.ensureQueryData(payoutsSummaryQueryOptions(token, filters));
		// eslint-disable-next-line @typescript-eslint/no-floating-promises
		queryClient.ensureQueryData(
			payoutLegsQueryOptions(token, filters, deps.page, deps.pageSize),
		);
	},
	pendingComponent: LoadingList,
	errorComponent: ErrorComponent,
});
